import { checkSession } from 'src/auth/auth0';
import { ErrorMessage } from 'src/shared/enum/ErrorMessage';
import { BasketUser } from 'src/store/slices/basket-slice';
import { Building } from 'src/store/types/building';
import { Room } from 'src/store/types/room';

import { studentBookingClient } from '../client';
import { StudentBookingSuccessResponse } from '../types';

import { BookingServiceEndpoints } from './constants';
import {
    BookingCalculatedDetails,
    BookingCalculationRequest,
    GetCheckBookingStatusSuccessResponse,
    PostBookingCalculateServiceSuccessResponse,
} from './types';

export const calculateBookingDetails = async (
    bookingDetails: BookingCalculationRequest
): Promise<BookingCalculatedDetails> => {
    const { data: response } =
        await studentBookingClient.post<PostBookingCalculateServiceSuccessResponse>(
            BookingServiceEndpoints.PostCalculateBookingDetails,
            bookingDetails
        );

    return response.data;
};

export const checkBookingStatus = async (
    bookingRecordId: string
): Promise<Record<string, string>> => {
    const { data: response } = await studentBookingClient.get<GetCheckBookingStatusSuccessResponse>(
        `${BookingServiceEndpoints.BaseUrl}/${bookingRecordId}/status`
    );
    return response.data;
};

export const getRoomByVitaRef = async (
    vitaRef: string
): Promise<{ room: Room; building: Building }> => {
    const session = await checkSession();
    if (!session) throw new Error(ErrorMessage.AUTH0_ID_ERROR);

    const { data: response } = await studentBookingClient.get<
        StudentBookingSuccessResponse<{ room: Room; building: Building }>
    >(`${BookingServiceEndpoints.BaseUrl}/${vitaRef}`, {
        headers: {
            Authorization: `Bearer ${session.idToken}`,
        },
    });
    return response.data;
};

export const UpdateOccupantDetails = async (details: { vitaRef: string; occupant: BasketUser }) => {
    const session = await checkSession();
    if (!session) throw new Error(ErrorMessage.AUTH0_ID_ERROR);

    const { data: response } = await studentBookingClient.post<StudentBookingSuccessResponse<null>>(
        BookingServiceEndpoints.PostUpdateOccupantDetails,
        details,
        {
            headers: {
                Authorization: `Bearer ${session.idToken}`,
            },
        }
    );

    return response.data;
};
